"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardSaveAreaMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardSaveAreaMixin */
/** @method */
var PropertyCardSaveAreaMixin = function PropertyCardSaveAreaMixin(props) {
  return (0, _styledToken.default)({
    columnGap: 'PropertyCard.saveArea.gap',
    marginTop: 'PropertyCard.saveArea.marginTop',
    marginRight: 'PropertyCard.saveArea.marginRight'
  }, function (_ref) {
    var columnGap = _ref.columnGap,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight;
    return (0, _styledComponents.css)(["display:grid;grid-auto-flow:column;grid-column-gap:", ";margin-top:calc(-1 * ", ");margin-right:calc(-1 * ", ");"], columnGap ? columnGap + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), marginTop ? marginTop + "px" : (0, _spaceMixin.spaceMixin)('xs')(props), marginRight ? marginRight + "px" : (0, _spaceMixin.spaceMixin)('xs')(props));
  })(props);
};
exports.PropertyCardSaveAreaMixin = PropertyCardSaveAreaMixin;